import React from 'react';
import { Navigate } from 'react-router-dom';
import { connect } from 'react-redux';

const VerifyIdentityRegistrationGuard = ({ children, authUser }) => {
    const cameFromResiRegistration =
        sessionStorage.getItem('resi-registration-verify-identity') === 'true';

    if (!authUser) {
        return <Navigate to="/login" replace />;
    }

    if (!cameFromResiRegistration) {
        return <Navigate to="/" replace />;
    }

    return children;
};

const mapStateToProps = ({ auth }) => ({
    authUser: auth.authUser
});

export default connect(mapStateToProps)(VerifyIdentityRegistrationGuard);
